export default function (Component) {
Component.options.__docs = "<p>You can hide the header by setting <code>headerVisible</code> to <code>false</code>. Without a header it is hard to tell which date is displayed/selected. Thus it is a good idea to render the currently displayed/selected date separately.</p>\n"
}